const actions = {
    FETCH_STREAMS: "FETCH_STREAMS",
    FETCH_STREAMS_SUCCESS: "FETCH_STREAMS_SUCCESS",
    FETCH_PROGRAMS: "FETCH_PROGRAMS",
    FETCH_PROGRAMS_SUCCESS: "FETCH_PROGRAMS_SUCCESS",
    FETCH_FULL_PROGRAM_SUCCESS: "FETCH_FULL_PROGRAM_SUCCESS",
    SET_PROGRAM: "SET_PROGRAM",
    HIDE_CREATE_PROGRAM_MODAL: "HIDE_CREATE_PROGRAM_MODAL",
    SHOW_CREATE_PROGRAM_MODAL: "SHOW_CREATE_PROGRAM_MODAL",
    HIDE_EDIT_WORKOUT_MODAL: "HIDE_EDIT_WORKOUT_MODAL",
    SHOW_EDIT_WORKOUT_MODAL: "SHOW_EDIT_WORKOUT_MODAL",
    CREATE_PROGRAM: "CREATE_PROGRAM",
    CREATE_PROGRAM_SUCCESS: "CREATE_PROGRAM_SUCCESS",
    CREATE_SERIES: "CREATE_SERIES",
    CREATE_SERIES_SUCCESS: "CREATE_SERIES_SUCCESS",
    ADD_CARD: "ADD_CARD",
    PROGRAMMING_ADD_EXERCISE: "PROGRAMMING_ADD_EXERCISE",
    ACTIVATE_PROGRAM: "ACTIVATE_PROGRAM",
    ACTIVATE_DAY: "ACTIVATE_DAY",
    ACTIVATE_SERIES: "ACTIVATE_SERIES",
    ADD_NEW_DA: "ADD_NEW_DAY",
    CLIPBOARD_DAY: "CLIPBOARD_DAY",
    PASTE_DAY: "PASTE_DAY",
    PASTE_SERIES: "PASTE_SERIES",
    SHOW_EDIT_ADDED_EXERCISE_MODAL: "SHOW_EDIT_ADDED_EXERCISE_MODAL",
    HIDE_EDIT_ADDED_EXERCISE_MODAL: "HIDE_EDIT_ADDED_EXERCISE_MODAL",
    ACTIVATE_EXERCISE: "ACTIVATE_EXERCISE",
    PATCH_STREAMS: "PATCH_STREAMS",

    SELECT_STREAM: "SELECT_STREAM",
    UPDATE_SERIES: "UPDATE_SERIES",
    PATCH_PROGRAM_SUCCESS: "PATCH_PROGRAM_SUCCESS",
    DELETE_EXERCISE_FROM_SERIES: "DELETE_EXERCISE_FROM_SERIES",
    UPDATE_SELECTED_PROGRAM: "UPDATE_SELECTED_PROGRAM",
    UPDATE_PROGRAM: "UPDATE_PROGRAM",
    SHOW_EDIT_DAY_MODAL: "SHOW_EDIT_DAY_MODAL",
    HIDE_EDIT_DAY_MODAL: "HIDE_EDIT_DAY_MODAL",
    UPDATE_DAY: "UPDATE_DAY",
    CREATE_DAY: "CREATE_DAY",
    SHOW_EDIT_PROGRAM_MODAL: "SHOW_EDIT_PROGRAM_MODAL",
    HIDE_EDIT_PROGRAM_MODAL: "HIDE_EDIT_PROGRAM_MODAL",
    SHOW_CREATE_STREAM_MODAL: "SHOW_CREATE_STREAM_MODAL",
    HIDE_CREATE_STREAM_MODAL: "HIDE_CREATE_STREAM_MODAL",
    SHOW_EDIT_STREAM_MODAL: "SHOW_EDIT_STREAM_MODAL",
    HIDE_EDIT_STREAM_MODAL: "HIDE_EDIT_STREAM_MODAL",
    DELETE_PROGRAM: "DELETE_PROGRAM",
    DEACTIVATE_PROGRAMS: "DEACTIVATE_PROGRAMS",
    ACTIVATE_STREAM: "ACTIVATE_STREAM",
    UPDATE_STREAM: "UPDATE_STREAM",
    PATCH_STREAM_SUCCESS: "PATCH_STREAM_SUCCESS",
    CREATE_STREAM: "CREATE_STREAM",
    SHOW_CREATE_EXERCISE_MODAL: "SHOW_CREATE_EXERCISE_MODAL",
    HIDE_CREATE_EXERCISE_MODAL: "HIDE_CREATE_EXERCISE_MODAL",
    SHOW_EDIT_EXERCISE_MODAL: "SHOW_EDIT_EXERCISE_MODAL",
    HIDE_EDIT_EXERCISE_MODAL: "HIDE_EDIT_EXERCISE_MODAL",
    SELECT_EXERCISE: "SELECT_EXERCISE",
    DELETE_DAY_FROM_PROGRAM: "DELETE_DAY_FROM_PROGRAM",
    SHOW_CREATE_DAY_MODAL: "SHOW_CREATE_DAY_MODAL",
    HIDE_CREATE_DAY_MODAL: "HIDE_CREATE_DAY_MODAL",
    SHOW_CREATE_SERIES_MODAL: "SHOW_CREATE_SERIES_MODAL",
    HIDE_CREATE_SERIES_MODAL: "HIDE_CREATE_SERIES_MODAL",
    SHOW_EDIT_SERIES_MODAL: "SHOW_EDIT_SERIES_MODAL",
    HIDE_EDIT_SERIES_MODAL: "HIDE_EDIT_SERIES_MODAL",
    DELETE_SERIES: "DELETE_SERIES",
    UPDATE_ADDED_EXERCISE: "UPDATE_ADDED_EXERCISE",
    CLEAR_SELECTED_DAY: "CLEAR_SELECTED_DAY",

    CLIPBOARD_SERIES: "CLIPBOARD_SERIES",
    CLIPBOARD_PROGRAM: "CLIPBOARD_PROGRAM",
    DEACTIVATE_STREAM: "DEACTIVATE_STREAM",
    SHOW_EDIT_PROGRAM_MODAL_SUCESS: "SHOW_EDIT_PROGRAM_MODAL_SUCESS",
    SET_THIS_PAYLOAD: "SET_THIS_PAYLOAD",
    FILTER_PROGRAM_FOR_ALL: "FILTER_PROGRAM_FOR_ALL",
    FILTER_PROGRAM_SPECIFIC_ATHLETES: "FILTER_PROGRAM_SPECIFIC_ATHLETES",
    SHOW_CREATE_PROGRESSION_EXERCISE: "SHOW_CREATE_PROGRESSION_EXERCISE",
    HIDE_CREATE_PROGRESSION_EXERCISE: "HIDE_CREATE_PROGRESSION_EXERCISE",
    PATCH_PROGRESSION_DAY: "PATCH_PROGRESSION_DAY",
    PATCH_DAYS: "PATCH_DAYS",
    SHOW_PUBLISHING_MODAL: "SHOW_PUBLISHING_MODAL",
    HIDE_PUBLISHING_MODAL: "HIDE_PUBLISHING_MODAL",
    SET_SELECTED_PROGRAM: "SET_SELECTED_PROGRAM",
    SHOW_TEAM_MODAL: "SHOW_TEAM_MODAL"
};
export default actions;
